// extracted by mini-css-extract-plugin
module.exports = {"container":"PrivateLayout_container__MO7RZ","content_wrapper":"PrivateLayout_content_wrapper__2hlIO","content":"PrivateLayout_content__10qcA"};